import styled from 'styled-components'

const Separator = styled.hr`
  width: 100%;
  margin: 0;
  border: none;
  border-bottom: 1px solid ${(props) => props.theme.color.blue[20]};
`
export default Separator
